import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, map, catchError, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * ActivationGuard - Guides users through the complete registration flow
 *
 * REGISTRATION FLOW ORDER:
 * 1. Register with Facebook ✓
 * 2. Choose Instagram Profile → /auth/choose-instagram
 * 3. Choose Plan → /auth/choose-plan
 * 4. Checkout and Pay → /auth/stripe-checkout
 * 5. Account Activation → /auth/account-activation (LAST STEP if pending_activation: true)
 * 6. Dashboard → /dashboard (when all completed)
 *
 * LOGIC:
 * - If no Instagram account → redirect to choose-instagram
 * - If no subscription → redirect to choose-plan
 * - If pending_activation: true → redirect to account-activation (FINAL STEP)
 * - If all completed → redirect to dashboard
 */
@Injectable({
  providedIn: 'root',
})
export class ActivationGuard {
  constructor(private authService: AuthService, private router: Router) {}
  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // If user is not authenticated, let other guards handle it
    if (!this.authService.isAuthenticated()) {
      return true;
    }

    // Guide user through registration flow: Instagram → Plan → Activation
    return this.authService.getUserProfile().pipe(
      map((profile: any) => {
        const userData = profile?.data;
        const facebookProvider = userData.socialAccounts?.find(
          (e: any) => e.provider === 'facebook'
        );
        console.log(userData)
        const instagramAccount = facebookProvider?.instagram_account;
        // Step 1: Check if user has selected Instagram account
        if (!instagramAccount) {
          return this.router.createUrlTree(['/auth/choose-instagram']);
        }

        // Step 2: Check if user has subscription
        if (!userData?.hasSubscriptions) {
          return this.router.createUrlTree(['/auth/choose-plan']);
        }

        // Step 3: Check if account verification is pending (LAST STEP)
        // if (userData?.pending_activation === true) {
        //   return this.router.createUrlTree(['/auth/account-activation']);
        // }

        // All steps completed, redirect to dashboard
        return true;
      }),
      catchError((error) => {
        console.error('Error checking activation status:', error);
        return of(true);
      })
    );
  }
}
